<template>
  <nav class="vc-breadcrumbs" :aria-label="$t('ui_kit.breadcrumbs.aria_label')">
    <ol class="vc-breadcrumbs__list">
      <template v-for="(item, i) in items" :key="i">
        <template v-if="i < items.length - 1">
          <li>
            <component
              :is="item.route ? 'router-link' : 'span'"
              :to="item.route"
              class="text-[color:var(--color-link)] hover:text-[color:var(--color-link-hover)]"
            >
              {{ item.title }}
            </component>
          </li>

          <li class="vc-breadcrumbs__item">
            <span class="vc-breadcrumbs__slash">/</span>
          </li>
        </template>

        <!-- Last breadcrumbs item -->
        <li v-else>
          <span v-if="productTitle">{{ productTitle }}</span>
          <span v-else>{{ item.title }}</span>
        </li>
      </template>
    </ol>
  </nav>
</template>

<script setup lang="ts">
interface IProps {
  items: IBreadcrumb[];
  productTitle?: string;
}

defineProps<IProps>();
</script>

<style lang="scss">
.vc-breadcrumbs {
  &__list {
    @apply flex flex-wrap text-sm font-normal;
  }

  &__item {
    @apply text-neutral;
  }

  &__link {
    @apply text-[--link-color];

    &:hover {
      @apply text-[--link-hover-color];
    }
  }

  &__slash {
    @apply mx-2 text-neutral-300;
  }
}
</style>
